import { MACHINE_TYPE } from 'constants/machine';
import useWebLogin from 'hooks/login/useWebLogin';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useDomainStore from 'stores/domain';
import { extractPath, extractUrlDomainType } from 'utils/extract/extractParams';

/**
 * domainType, WebInitInfo 를 셋팅한다.
 */
const useDomainTypeAndWebInitInfo = () => {
  const location = useLocation();
  const domainStore = useDomainStore();
  const webLoginManager = useWebLogin();

  const getWebInfo = async () => {
    const clientPath: string = extractPath(location.pathname);
    try {
      if (!clientPath) return;
      await webLoginManager.getWebInitInfo({ clientPath });
    } catch (error) {
      console.error('Unable to load client path', error);
    }
  };

  const init = () => {
    const domainType = extractUrlDomainType(location);
    domainStore.setDomainType(domainType);
    if (domainType === MACHINE_TYPE.WEB || domainType === MACHINE_TYPE.FAKE_DESKTOP) getWebInfo();
  };

  useEffect(() => {
    init();
  }, []);
};
export default useDomainTypeAndWebInitInfo;
